<template>
  <div v-loading="loading">
    <div class="search-form">
      <custom-top-flag-select
        v-model="config.topFlag"
        style="margin-right: 10px;" />
      <el-input
        v-model="config.goodsName"
        clearable=""
        style="width: 240px;"
        placeholder="请输入产品名称">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="fetch"></el-button>
      </el-input>
    </div>
    <el-table
      :data="list"
      border="">
      <el-table-column
        prop="goodsName"
        label="产品名称"
        min-width="240"></el-table-column>
      <el-table-column
        label="操作"
        width="110">
        <template slot-scope="{row}">
          <el-button
            :disabled="row.topFlag === 1"
            type="text"
            @click="topflag(row, 1)">上首页</el-button>
          <el-button
            type="text"
            :disabled="row.topFlag === 0"
            @click="topflag(row, 0)">下首页</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div style="font-size: 14px;margin-top: 20px;font-weight: bold;">进行上下首页后，刷新页面可以看到左侧效果，如果当前组件是新增的，请先保存</div>
  </div>
</template>
<script>
import Goods from '@/service/goods'
import Portal from '@/service/portal'
import CustomTopFlagSelect from './custom-top-flag-select.vue'
export default {
  name: 'GoodsTopList',
  components: { CustomTopFlagSelect },
  data() {
    return { loading: false, list: [], total: 0, config: { goodsName: '', pageNum: 1, pageSize: 10, status: 1, topFlag: 1 }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    topflag(row, topFlag) {
      this.$confirm(`是否${topFlag === 1 ? '上' : '下'}首页`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Portal.goodstopflag({ exchangeGoodsId: row.exchangeGoodsId, topFlag })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if (result === 0) {
                this.$message.success('设置成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    fetch() {
      this.config.pageNum = 1
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Goods.getgoodslist({ ...this.config })
        .then(res => {
          const { result, message, records, total } = res.data
          this.loading = false
          if ([0].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex
  align-items: center
  justify-content: flex-end
  margin-bottom: 10px
}
</style>
